var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgS2MigrationWarningLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.83267 1.09729C7.09176 1.05879 7.35561 1.12348 7.56751 1.27746C7.77941 1.43144 7.92243 1.66242 7.96584 1.92073C8.00924 2.17905 7.94955 2.44408 7.79961 2.65886C7.64967 2.87364 7.42145 3.02101 7.164 3.06929C5.99931 3.26681 4.94217 3.87032 4.17998 4.77286C3.41778 5.67539 2.99975 6.81864 3 7.99996C3 9.32604 3.52678 10.5978 4.46447 11.5355C5.40215 12.4732 6.67392 13 8 13V15C4.134 15 1 11.8666 1 7.99996C1 4.56996 3.484 1.65996 6.83267 1.09729Z",
    fill: "url(#paint0_linear_7641_1697)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2613 2.86525C11.349 2.76741 11.4551 2.68782 11.5736 2.63101C11.6921 2.57421 11.8206 2.5413 11.9518 2.53418C12.083 2.52706 12.2143 2.54587 12.3382 2.58952C12.4621 2.63317 12.5762 2.70081 12.674 2.78858C13.4066 3.4446 13.9925 4.2479 14.3933 5.14593C14.7942 6.04396 15.0009 7.01649 15 7.99991C15 11.8666 11.866 14.9999 8 14.9999V12.9999C9.01211 12.9999 10.0004 12.6928 10.8342 12.1191C11.668 11.5454 12.3081 10.7322 12.6698 9.78694C13.0316 8.84168 13.0979 7.8089 12.8601 6.82513C12.6223 5.84136 12.0915 4.95291 11.338 4.27725C11.1406 4.10016 11.0216 3.85192 11.0073 3.58712C10.9929 3.32233 11.0843 3.06267 11.2613 2.86525Z",
    fill: "url(#paint1_linear_7641_1697)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7641_1697",
    x1: 351,
    y1: 74.4247,
    x2: 351,
    y2: 1278.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.55
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7641_1697",
    x1: 12.3333,
    y1: 2.6665,
    x2: 8.66667,
    y2: 13.9998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552441,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS2MigrationWarningLoading);
export default __webpack_public_path__ + "static/media/s2_migration_warning_loading.6f33cc7c12a317ce7371f0e45c9fabe0.svg";
export { ForwardRef as ReactComponent };